import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { E_CONTENTS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/e-contents/new")({
  component: () => <DeptContentForm cfg={E_CONTENTS} />,
});
